<template>
  <div class="infor fl">
    <AllHeader
      :label="lable"
      :ischage="ischage"
      :sublabel="sublabel"
      :subtitle="subtitle"
      @getvalue="getvalue"
    />
    <div class="stepContainer" v-if="list && step > 0">
      <div v-for="(item, index) in list" :key="index">
        <div class="stepcone">
          <div
            class="line"
            v-if="index <= list.length - 1"
            :style="{ width: (10 - list.length) * 48 + '%' }"
          ></div>
          <div
            class="stepItem"
            :class="{
              isactibe: item.success,
              stponce: step == index,
              error: isFail == 'fail' && step == 3 && index == step,
            }"
          >
            <i
              class="el-icon-check"
              v-if="index + 1 < list.length && step != index"
              style="color: white"
            ></i>
            <span v-if="index + 1 < list.length && step == index">{{
              index + 1
            }}</span>
            <img
              src="../assets/np18.png"
              v-if="step != 4 && index + 1 == list.length"
            />
            <img
              src="../assets/18.png"
              v-if="step == 4 && index + 1 == list.length"
            />
            <img
              src="../assets/down.png"
              v-if="step == index"
              alt
              class="downpng"
            />
          </div>

          <span
            v-if="isFail == 'fail' && step == 3 && index == step"
            class="erroritem stepTitle"
            >审核不通过</span
          >
          <span
            v-else
            class="stepTitle"
            :class="{
              successtitle: item.success,
              stpotitle: step == index,
              erroritem: item.error,
            }"
            >{{ item.title }}</span
          >
        </div>
      </div>
    </div>
      <div class="block-list" v-if="step == -1">
          <div
              v-for="(item, index) in awardList"
              :key="index"
              class="block-list-item"
          >
              <div class="block-list-item-r-t">国家级</div>
              <div class="block-list-item-box">
                  <div class="block-list-item-box-t">{{ item.title }}</div>
                  <div class="block-list-item-box-startend">
                      共{{item.count}}条记录
                  </div>
              </div>
              <div
                  class="block-list-item-box-b"
                  @click="awardrecordList(1,item.id,item.title)"
              >
                  申报记录
              </div>
          </div>
      </div>
    <div v-if="step == 0" ref="pdf">
      <div>
        <el-table
          :data="recordlist"
          :header-cell-style="{ background: '#FEF8EF', color: '#7C828A' }"
          style="width: 100%; margin-top: 30px"
        >
          <el-table-column prop="award.year" label="平常年份" min-width="80">
          </el-table-column>
          <el-table-column prop="award.title" label="申报奖项" show-overflow-tooltip min-width="160">
          </el-table-column>
          <el-table-column  label="项目名称" min-width="130">
              <template slot-scope="scope">
                <span v-if="scope.row.award_id==12">{{scope.row.content.info.name}}</span>
                  <span v-else-if="scope.row.award_id==9&&scope.row.content!=null&&scope.row.content.Contractorinfo!=null">{{scope.row.content.Contractorinfo.projectNname}}</span>
                <span v-else-if="scope.row.award_id==13">{{scope.row.content.info.msg1}}</span>
                <span v-else></span>
              </template>
          </el-table-column>
            <el-table-column label="申报人" min-width="130">
                <template slot-scope="scope">
                    <span v-if="scope.row.content!=null&&scope.row.content.candidate!=null">{{scope.row.content.candidate.msg1}}</span>
                    <span v-else></span>
                </template>
            </el-table-column>
          <el-table-column label="项目经理" min-width="80">
              <template slot-scope="scope">
                  <span v-if="scope.row.award_id==12">{{scope.row.content.info.name}}</span>
                  <span v-else-if="scope.row.award_id==9&&scope.row.content!=null&&scope.row.content.Contractorinfo!=null">{{scope.row.content.Contractorinfo.projectNname}}</span>
                  <span v-else-if="scope.row.award_id==13">{{scope.row.content.info.msg1}}</span>
                  <span v-else></span>
              </template>
          </el-table-column>
          <el-table-column prop="created_at" label="申报时间" min-width="100">
          </el-table-column>
          <el-table-column min-width="100" prop="statustext" label="审核状态">
          </el-table-column>
          <el-table-column
            fixed="right"
            prop="operation"
            width="200px"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="
                  detail(scope.row.id, scope.row.status, scope.row.award.title,scope.row.file_urls,scope.row.content)
                "
                >{{ scope.row.operation }}</el-button
              >
              <el-button @click="Appendix(scope.row.content.info.msg1,scope.row.id)" v-if="scope.row.award_id==13&&scope.row.status==4&&!scope.row.file_urls" size="mini">传附件</el-button>
                <el-button @click="openUpload(scope.row.id)" v-if="scope.row.award_id==9" size="mini">补充材料</el-button>
            </template>
          </el-table-column>
        </el-table>
        <Pagetion
          :total="total"
          @getpageValue="getpageValue"
          class="pos-page"
        />
      </div>
        <el-dialog  title="上传补充材料" :visible.sync="dialogUploadVisible" :center="true" :before-close="handleClose">
            <div class="form_1">
                <div class="form_box_content">
                    <div class="my_form2">
                        <div class="form_title" style="height: 62px">材料名称</div>
                        <div class="form_long">
                            <input placeholder="请输入" v-model="supplementName" type="text"/>
                        </div>
                    </div>
                    <div class="my_form">
                        <div class="form_title" style="height: 93px">上传附件</div>
                        <div class="form_long">
                            <el-upload
                                class="upload-demo2"
                                :action="$baseURL + '/api/home/upload/file/award_log'"
                                :on-preview="handlesupplementPreview"
                                :data="{ token: token }"
                                accept=".doc, .docx, .xls, .xlsx, .pdf, .zip, .rar"
                                :on-remove="handlesupplementRemove"
                                :file-list="filesupplementList"
                                :on-success="handlesupplementAdd"
                                :on-error="handlesupplementError"
                                list-type="text"
                                :limit="1">
                                <el-button
                                    size="small"
                                    icon="el-icon-upload2"
                                    style="color: #194abe"
                                >点击选择文件</el-button>
                                <div slot="tip" class="el-upload__tip">
                                    {{filesupplementList.length==0?'仅支持doc,docx,xls,xlsx,ppt,zip,rar格式，大小不超过50mb':''}}
                                </div>
                            </el-upload>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
              <el-button @click="supplementClose">取消</el-button>
              <el-button @click="supplementSubmit" type="primary" >确认</el-button>
            </span>
        </el-dialog>
    </div>
    <div v-if="step == 1">
      <Lineconbgtir :labelcontainer="labelcontainertow" />
      <div class="infor-c">
        中天城投集团是全省唯一一家房地产上市公司，中天城投集团是贵州省两个具有壹级开发资质的企业之一，无论土地资源储备、开发规模、资金实力，还是企业影响力、治理结构、管理基础，始终保持贵州省内房地产行业龙头企业的地位，是贵州省的房地产著名品牌。
        二十余年来，中天城投集团以超前的意识、敏锐的目光，通过所开发的四代住宅小区的示范效应，形成了在贵州具有广泛影响力的中天住宅品牌。成功开发中天花园、中天·世纪新城、中天会展城等项目，同时涵盖物业、健身、教育等产业，并且这些产业都是有口皆碑的。现在中天中天城投集团着重开发未来方舟这个超级大盘。中天城投集团是全省唯一一家房地产上市公司，中天城投集团是贵州省两个具有壹级开发资质的企业之一，无论土地资源储备、开发规模、资金实力，还是企业影响力、治理结构、管理基础，始终保持贵州省内房地产行业龙头企业的地位，是贵州省的房地产著名品牌。
        二十余年来，中天城投集团以超前的意识、敏锐的目光，通过所开发的四代住宅小区的示范效应，形成了在贵州具有广泛影响力的中天住宅品牌。成功开发中天花园、中天·世纪新城、中天会展城等项目，同时涵盖物业、健身、教育等产业，并且这些产业都是有口皆碑的。现在中天中天城投集团着重开发未来方舟这个超级大盘。
      </div>

      <Lineconbgtir :labelcontainer="Documentedit" class="margin-top-40" />
      <p style="margin-top: 40px; text-align: start">
        本奖项为线上申报，请点击下方按钮进入申报表单填报页面
      </p>
      <Downinpu :downlist="downlist" v-if="faile" />
      <el-button
        icon="el-icon-edit"
        style="
          color: #194abe;
          border: 1px solid #194abe;
          width: 189px;
          height: 50px;
          font-size: 18px;
          margin-top: 50px;
        "
        size="small"
        :disabled="false"
        @click="onSubmitTap"
        >开始填写资料</el-button
      >
    </div>
    <div v-if="step === 2">
      <div class="shenhjrkr" v-if="isFail =='pendding'">
        <img src="../assets/shenhr.png" alt />
        <p style="font-size: 16px; color: #333333">待专家审核中...</p>
        <p style="font-size: 10px; color: #9fa5ae; margin: 10px 0">
          正在审核您提交的资料，请稍后查看结果
        </p>
      </div>
      <div class="shenhjrkr" v-if="isFail =='distribution'">
        <img src="../assets/shenhr.png" alt />
        <p style="font-size: 16px; color: #333333">待分配专家...</p>
        <p style="font-size: 10px; color: #9fa5ae; margin: 10px 0">
          正在审核您提交的资料，请稍后查看结果
        </p>
      </div>
    </div>
    <div v-if="step === 3">
      <div class="shenhjrkr" v-if="isFail == 'pendding'">
        <img src="../assets/shenhr.png" alt />
        <p style="font-size: 16px; color: #333333">待平台审核中</p>
        <p style="font-size: 10px; color: #9fa5ae; margin: 10px 0">
          正在审核您提交的资料，请稍后查看结果
        </p>
      </div>
      <div v-if="isFail == 'fail'">
        <div class="shenhjrkr">
          <img src="../assets/faile.png" alt />
          <p style="font-size: 20px; color: #333333">审核未通过</p>
          <p style="font-size: 16px; color: #e51725; margin: 10px 0">
            未通过原因：{{ reason }}
          </p>
          <p style="font-size: 16px; color: #9fa5ae; margin: 10px 0">
            请修改后重新提交
          </p>
          <div class="flex-left">
            <el-button
              size="small"
              icon="el-icon-edit"
              style="
                color: #194abe;
                border: 1px solid #194abe;
                width: 189px;
                height: 50px;
                font-size: 18px;
                margin-top: 50px;
                background: #fff;
                margin: 0 auto;
              "
              class="block-submit"
              @click="now_modify"
              >现在去修改</el-button
            >
          </div>
        </div>
      </div>
      <div class="shenhjrkr" v-if="(isFail == 'response'&&modifyID!=13)||(isFail == 'response'&&modifyID==13&&isfile_urls)">
          <img src="../assets/failesucee.png" alt />
          <p style="font-size: 20px;color:#333333">已通过平台审核</p>
          <p style="font-size: 16px;color: #9FA5AE;margin: 10px 0">请下载您所提交资料的打印文件，打印后补充盖章、日期、签名等空缺</p>
            <div class="flex-left">
              <el-button
                size="small"
                icon="el-icon-printer"
                style="color:#194ABE;border:1px solid #194ABE;width:189px;height:50px;font-size:18px;margin-top:50px;background:#fff;margin:0 auto"
                class="block-submit"
                @click="downfile"
              >下载打印文件</el-button>
            </div>
            <div>
        </div>
      </div>
    </div>
    <div v-if="step == 4">
      <div v-if="!address">
        <div>
        <Lineconbgtir :labelcontainer="labelcontaineragain" style="margin-top: 20px" />
        <p style="font-size: 16px;color: #9FA5AE;margin: 10px 0 0 ;text-align:start">下载打印文件并补充盖章、日期、签名后，将表单内容以电子档形式上传，提交审核后进入下一流程。</p>
        <div class="upload">
          <el-upload
            class="upload-demo"
            :action="$baseURL+'/api/home/upload/file/award_log'"
            :on-preview="handlePreview"
            :data="{token:token}"
            accept=".doc, .docx, .xls, .xlsx, .pdf, .zip, .rar"
            :on-remove="handleRemove"
            :file-list="fileList"
            :on-success="handleAdd"
            :on-error="handleError"
            list-type="text"
          >
            <div class="uploadheader">
              <span>上传文件</span>
              <el-button size="small" icon="el-icon-upload2" style="color: #194ABE">点击选择文件</el-button>
              <span v-if="showErr" class="el-upload__tip margin-left-30" slot="tip">
                <i class="el-icon-error"></i>支持格式：doc,docx,xls,xlsx,ppt,pptx,pdf,zip,rar&nbsp;&nbsp;(请上传小于50M的文件)。
              </span>
            </div>
          </el-upload>
        </div>

        <div class="flex-left">
          <el-button
            size="small"
            icon="el-icon-check"
            style="background-color: #194ABE;color: white;margin-bottom: 20px"
            class="block-submit"
            @click="onSubmitTap"
          >提交专家审核</el-button>
        </div>
        </div>
      </div>

      <div v-else>
        <div class="shenhjrkr">
          <img src="../assets/failesucee.png" alt />
          <p style="font-size: 20px; color: #333333">奖项申请成功</p>
          <p style="font-size: 16px; color: #9fa5ae; margin: 10px 0">
            我们会尽快将奖项证书发放给您，如需修改地址请联系400-888-8888
          </p>
          <div class="block-addr">
            <span class="span-l">已提交的收货地址：</span>
            <span class="span-r">{{ address }}</span>
            <!-- <el-input type="textarea" rows="5" placeholder="请输入您的收货地址" v-model="textarea" class="textarea">
            </el-input>-->
          </div>
        </div>
      </div>
    </div>
    <Huangguoshu
      v-if="isdownload&&modifyID==9"
      :alldata="content"
      @previewDom="previewDom"
    />
    <Lvshe
      v-if="isdownload&&modifyID==13"
      :alldata="content"
      @previewDom="previewDom"
    />
    <ProjectManager
      v-if="isdownload&&modifyID==15"
      :alldata="content"
      @previewDom="previewDom"
    />
    <Construction
      v-if="isdownload&&modifyID==14"
      :alldata="content"
      @previewDom="previewDom"
    />
  </div>
</template>

<script>
import Huangguoshu from "@/components/word/preview_5.vue";
import Lvshe from "@/components/word/preview_2.vue"
import ProjectManager from "@/components/word/preview_1.vue"
import Construction from "@/components/word/preview_3.vue"
import Lineconbgtir from "./Modal/Line";
import Downinpu from "@/components/Modal/Downinpu";
import Pagetion from "@/components/Modal/Pagetion";
import AllHeader from "@/components/Modal/AllHeader";
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";
import FromProject from "./fromProjcet/greenProject.vue"
import {
    submitFileHgs,
    AwardInfoList,
    DeclareDetails,
    AwardList,
    AwardInfo, //申报记录详情
    AwardLog, //申报奖项
    Address, AwardListWithCount, submitFile, //填写地址
} from "../utils/api.js";
export default {
  name: "DeclarRecord",
  components: {
    AllHeader,
    Pagetion,
    // Steps,
    Lineconbgtir,
    Downinpu,
    Huangguoshu,
    Lvshe,
    ProjectManager,
    Construction,
    FromProject
  },
  data() {
    return {
        dialogUploadVisible:false,
      projectname:'',//项目名称
      isfile_urls:null,//利用file_urls判断绿色施工是否第二次上传资料
      content: {},//表单数据
      isdownload: false,//需要下载得页面是否显示
      total: 1,
      sublabel: "返回记录列表",
      subtitle: "",
      ischage: "",
      lable: "",
      recordlist: [],
      list: [
        {
          title: "选择奖项",
          isred: true,
        },
        {
          title: "资料上传",
          isred: true,
        },
          {
              title: "专家审核",
              isred: true,
          },
        {
          title: "平台审核",
          isred: true,
        },
        {
          title: "完成",
          isred: true,
        },
      ],
      awardList: [], //奖项列表
      address: "", //收货地址
      reason: "", //审核未通过原因
      file_urls: [],
      modifyID: "",//奖项id
      showErr: false,
      isFail: "pending", //审核状态是否失败 fail(失败) pending(审核中) response(成功)
      id: "",
      token: "",
      pageSize: 10,
      step: -1,
      fileList: [],
        filesupplementList:[],
      textarea: "",
      labelcontainertow: {
        lable: "申请须知",
        desc: "Application Notes",
      },
      Documentedit: {
        lable: "填写申请表单",
        desc: "Document edit",
      },
      labelcontainerdeclare: {
        lable: "请选择您要申报的奖项",
        desc: "",
      },
      labelcontainer: {
        lable: "开始上传",
        desc: "Document download",
      },
      labelcontaineragain: {
        lable: "上传附件",
        desc: "Upload the completed form",
      },
      labelcontainerdow: {
        lable: "申请文档下载",
        desc: "Document download",
      },
      downlist: [
        {
          name: "会员申请表",
          url: "www.baidu.com",
        },
        {
          name: "会员申请表会员申请表会员申请表会员...",
          url: "www.baidu.com",
        },
      ],
        supplementName:"",//补充材料名词
        currentSupplementId:0,
        currentId:0,
        currentSubTitle:''
    };
  },
  mounted() {
    this.lable = this.$route.query.name;
    this.token = "Bearer " + localStorage.getItem("TOKEN");
    this.initList(1);
  },
  methods: {
    //传附件
    Appendix(name,id){
      this.$router.push('/member/uploadAppendix?id='+id+'&name=ttttt')
    },
      openUpload(id){
        this.dialogUploadVisible = true;
        this.currentSupplementId = id;
      },
    //下载PDF
    getPdf(ref) {
      let _this = this;
      html2Canvas(ref, {
        allowTaint: true,
        useCORS: true,
      }).then(function (canvas) {
        console.log(999, canvas);
        // const width = ref.offsetWidth
        // const height = ref.offsetHeight
        var context = canvas.getContext("2d");
        context.mozImageSmoothingEnabled = false;
        context.webkitImageSmoothimgEnabled = false;
        context.msImageSmoothingEnabled = false;
        context.imageSmoothingEnabled = false;
        let contentWidth = canvas.width;
        let contentHeight = canvas.height;
        let pageHeight = (contentWidth / 592.28) * 841.89;
        let leftHeight = contentHeight;
        let position = 0;
        let imgWidth = 595.28;
        let imgHeight = (592.28 / contentWidth) * contentHeight;
        let pageData = canvas.toDataURL("image/jpeg/png/jpg", 1.0);
        let PDF = new JsPDF("", "pt", "a4");
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
            leftHeight -= pageHeight;
            position -= 841.89;
            if (leftHeight > 0) {
              PDF.addPage();
            }
          }
        }
        PDF.save(_this.subtitle + ".pdf");
        _this.isdownload = false;
      });
    },
    previewDom(v) {
      this.getPdf(v);
    },
    downfile() {
      this.isdownload = true;
    },
    detail(id, status, title, file_urls,content) {
      if (content&&content.info) {
        this.projectname = content.info.msg1
      }

      this.isfile_urls = file_urls
      this.onApplyTap(id, status, title);
    },
    //申报奖项记录列表
    async awardrecordList(page,award_id,title){
        if(award_id){
            this.currentId = award_id;
            this.currentSubTitle = title;
        }
      const data = {
        page_size: this.pageSize,
        page: page,
          award_id:this.currentId,
      };
      this.lable = this.$route.query.name;
      let res = await AwardInfoList(data);
      console.log(987, res);
      this.step = 0;
      this.ischage = true;
        this.subtitle = this.currentSubTitle;
      this.total = res.total;
      res.data.forEach((element) => {
        element.created_at = element.created_at.replace(/\s[\x00-\xff]*/g, "");
        if (element.status == 1) {
          element.statustext = "待分配专家";
          element.operation = "详情";
        }
        if (element.status == 2) {
          element.statustext = "待专家审核";
          element.operation = "详情";
        }
        if (element.status == 3) {
          element.statustext = "待平台审核";
          element.operation = "详情";
        }
        if (element.status == 4) {
          element.statustext = "审核通过";
          element.operation = "详情";
        }
        if (element.status == 5) {
          element.statustext = "审核不通过";
          element.operation = "详情";
        }
      });
      this.recordlist = res.data;
    },
    //奖项列表
    async initList(page) {
      const data = {
        page_size: this.pageSize,
        page: page,
      };
      let res = await AwardListWithCount(data);
      this.awardList = res.data || [];
    },
    // 去申请查看申请信息
    async onApplyTap(id, status, title) {
      if (status) {
        DeclareDetails(id)
          .then((res) => {
            this.content = res.content;
            if (res.award_id) {
              this.id = res.id;
              this.modifyID = res.award_id;
              if (res.status == 5) {
                //审核不通过
                this.step = 3;
                this.isFail = "fail";
                this.reason = res.reject_reason || "";
              }
              if (res.status == 4) {
                //审核通过
                this.step = 3;
                this.isFail = "response";
                this.address = res.address || "";
              }
              if (res.status == 3) {
                //待平台审核
                this.step = 3;
                this.isFail = "pendding";
                this.reason = res.reject_reason || "";
              }
              if (res.status == 2) {
                //待专家审核
                this.step = 2;
                this.isFail = "pendding";
                this.address = res.address || "";
              }
              if (res.status == 1) {
                //待分配专家
                this.step = 2;
                this.isFail = "distribution";
                this.reason = res.reject_reason || "";
              }
            }
            //  else {
            //   //去填写资料
            //   this.step = 1;
            //   this.ischage = false;
            //   this.id = id;
            // }
            this.ischage = true;
            this.subtitle = title;
          })
          .catch((err) => {
            this.$message.error(err);
          });
      }
    },
    handleAdd(response, file, fileList) {
      this.setUrls(fileList);
    },
    handleRemove(file, fileList) {
      this.setUrls(fileList);
    },
    handlePreview(file) {
    },
      handlesupplementAdd(response, file, fileList) {
        this.filesupplementList = fileList;
          console.log(this.filesupplementList,'handlesupplementAdd');
      },
      handlesupplementRemove(file, fileList) {
          this.filesupplementList=[];
          console.log(this.filesupplementList,'handlesupplementRemove');
      },
      handlesupplementPreview(file) {
      },
      handlesupplementError(){
      },
    //获取上传数组
    setUrls(fileList) {
      let urls = [];
      fileList.map((item) => {
        urls.push(item.response.data.host + item.response.data.url);
      });
      this.file_urls = urls;
      console.log(this.file_urls);
    },
    handleError(err, file, fileList) {
      this.showErr = true;
      let that = this;
      setTimeout(function () {
        that.showErr = false;
        console.log(that.showErr);
      }, 2000);
      // console.log(this.showErr);
    },
    //现在去修改
    now_modify() {
      if (this.isFail == 'fail'&&this.modifyID == 13&&this.isfile_urls) {
        this.$router.push('/member/uploadAppendix?id='+this.id+'&name='+this.subtitle)
        return false
      }
      this.$router.push(`/form?title=${this.subtitle}&id=${this.modifyID}&r=${this.id}`);
    },
    // 提交审核
    onSubmitTap() {
      // this.$router.push(`/form?title=${this.subtitle}&id=${this.id}`);
      if (this.file_urls.length && this.id) {
        const data = {
          award_id: this.id,
          file_urls: this.file_urls
        };
        AwardLog(data).then(res => {
          console.log(res);
          this.step = 3;
          this.isFail = false;
        });
      } else {
        this.$message({
          message: "请上传文档",
          type: "warning"
        });
      }
    },
    // 提交地址
    async onAddressTap() {
      if (this.textarea) {
        let id = this.id;
        let addr = this.textarea;

        Address(id, addr)
          .then((res) => {
            this.address = addr;
          })
          .catch((err) => {
            this.$message.error(err.response.data.message);
          });
      } else {
        this.$message.warning("请填写地址");
      }
    },
    getvalue() {
        console.log(this.step);
        if(this.step==0){
            this.step = -1;
            this.ischage = false;
            this.subtitle = "";
        }
        else{
            this.step = 0;
        }
    },

    getpageValue(index) {
      // console.log(index);
      // this.initList(index);
      this.awardrecordList(index)
    },
    greenPorject(v,is){
      console.log(v,is);
    },
      handleClose(done){
          this.supplementName = '';
          this.filesupplementList = [];
          done();
      },
      supplementClose(){
        this.dialogUploadVisible = false;
          this.supplementName = '';
          this.filesupplementList = [];
      },
      supplementSubmit(){
        if(!this.supplementName){
            this.$message.error('请输入材料名词');
            return;
        }
        if(this.filesupplementList.length<=0){
            this.$message.error('请上传附件');
            return;
        }
          const data = {
              file_urls:this.supplementName+","+this.filesupplementList[0].response.data.host+this.filesupplementList[0].response.data.url
          };
        let that = this;
          submitFileHgs(data, this.currentSupplementId).then((res) => {
              console.log(res);
              if (res) {
                  this.$message({
                      type: "success",
                      message: '保存成功',
                  });
                  that.dialogUploadVisible = false;
                  that.supplementName = '';
                  that.filesupplementList = [];
              }else{
                  this.$message({
                      type: "error",
                      message: '保存失败',
                  });
              }
          });
      }
  },
};
</script>

<style lang="less" scoped>
.applybut {
  padding: 6px 15px;
}
/deep/.block-title {
  border-left: 3px solid #194abe !important;
}
/deep/.el-upload-list{
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  text-align: start;
  height: auto;
}

.textarea {
  width: 382px;
  // height: 92px;
  background: #ffffff;
  border: 1px solid #bdc3cb;
  opacity: 1;
  border-radius: 4px;
}

.block-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 20px 0;

  &-item {
    width: 370px;
    background: #ffffff;
    border: 1px dashed #c8cdd5;
    padding: 24px 25px;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 21px;
    position: relative;
    &-r-t {
      position: absolute;
      top: 0;
      right: 0;
      width: 73px;
      height: 27px;
      background: #f5f9fb;
      opacity: 1;
      border-radius: 0px 0px 0px 80px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 27px;
      color: #c6c9ce;
      padding-left: 10px;
      box-sizing: border-box;
    }
    &-box {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: flex-start;
      &-t {
        width: 244px;
        color: #0c0d0f;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-align: justify;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: 400;
      }
      &-dtae {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        line-height: 26px;
        color: #194abe;
      }
      &-startend {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 26px;
        color: #7c828a;
          margin-top:10px;
      }
      &-b {
        width: 91px;
        height: 32px;
        background: #ffffff;
        border: 1px solid #194abe;
        color: #194abe;
        opacity: 1;
        border-radius: 6px;
        text-align: center;
        line-height: 32px;
        font-size: 14px;
        cursor: pointer;
      }

      &-b-d {
        background: #ffffff !important;
        border: 1px solid #d4dbdd !important;
        color: #c8cdd5 !important;
      }

      &-b-s {
        background: #d4dbdd !important;
        border: 1px solid #d4dbdd !important;
        color: #ffffff !important;
      }
    }
  }
}

.margin-bottom-40 {
  margin-bottom: 40px;
}

.infor {
  padding-bottom: 40px;
  min-height: 800px;
  margin-bottom: 34px;
  position: relative;
}

.upload-demo {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.upload-demo2{
    justify-content: flex-start;
    align-items: flex-start;
    width:480px;
}
.uploadheader {
  height: 60px;
  width: 100%;
  display: flex;
  align-items: center;

  span {
    margin-right: 10px;
    color: #71767c;
  }
}

.margin-top-40 {
  margin-top: 40px;
}

.block-solid {
  width: 100%;
  height: 2px;
  background-color: #e51725;
  margin-top: 30px;
}

.shenhjrkr {
  margin: 71px 0 100px 0;

  img {
    width: 120px;
  }
}

.stepContainer {
  width: 100%;
  height: 160px;
  background-color: #f6f6f6;
  margin: 20px 0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  overflow: hidden;

  .stepcone {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    .stepItem {
      width: 50px;
      height: 50px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      background-color: #9fa5ae;
      border: 1px solid #9fa5ae;
      font-size: 32px;
      font-weight: 900;
      color: #c8cdd5;
      z-index: 999;

      .downpng {
        position: absolute;
        top: -20px;
        width: 20px;
        height: auto;
      }
    }

    img {
      width: 27px;
      height: auto;
    }

    .isactibe {
      color: white;
      // border: 1px solid #9FA5AE;
      // background-color: #9FA5AE;
    }

    .stponce {
      color: #194abe;
      border: 1px solid #194abe;
      background-color: white;
    }

    .error {
      color: #e51725;
      border: 1px solid #e51725;
      background-color: white;
    }

    .stepTitle {
      font-size: 18px;
      color: #c8cdd5;
      margin-top: 10px;
    }

    .successtitle {
      color: #0c0d0f;
    }

    .stpotitle {
      color: #194abe;
    }

    .erroritem {
      color: #e51725;
    }

    .line {
      width: 350%;
      flex: 1;
      flex-shrink: 0;
      height: 2px;
      border-bottom: 1px dashed #d4dbdd;
      position: absolute;
      top: 25px;
      left: 85%;
    }
  }
}
.block-addr {
  display: inline-block;
  padding: 13px 32px;
  background-color: #fff7e8;
  font-size: 14px;
  margin-top: 31px;
  .span-l {
    color: #9fa5ae;
  }
  .span-r {
    color: #194abe;
  }
}
.form_1 .form_box_content .form_title{
    box-sizing: border-box;
    text-align: start;
    display: flex;
    align-items: center;
}
.my_form2, .my_form{
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    overflow: visible;
    align-items: stretch;
}
.my_form2 .form_title,  .my_form .form_title{
    background: #eaf0f6;
    width: 129px;
    min-width: 129px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 20px;
    padding: 6px;
    box-sizing: border-box;
    color: #0c0d0f;
}
.my_form2 .form_long,.my_form .form_long{
    width: 700px;
    padding: 0 6px;
    background: #f5f8fb;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}
.my_form2 .form_long input, .my_form .form_long input{
    width: 488px;
    height: 36px;
    background: #fff;
    border: 1px solid #bdc3cb;
    opacity: 1;
    border-radius: 4px;
    padding: 0 15px;
    box-sizing: border-box;
}
.my_form2 .form_title {
    background: #f5f8fb;
}
.my_form2 .form_long{
    background: #fbfdff;
}
</style>

